import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { verifyNewBankCard } from 'services/bankManagements'

export default function useSetVerifiedCard() {
    const navigate = useNavigate()
    const { isLoading, mutate, data } = useMutation({
        mutationFn: (cardNumber: number) => {
            return verifyNewBankCard(cardNumber)
        },
        onSuccess: (_, variables) => {
            toast.success('کارت با موفقیت ثبت شد')
            navigate(-1)
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutateVerify: mutate, data }
}
